import React, { useEffect, useCallback, useState } from 'react';
import _ from 'lodash';
import moment from 'moment';

import {
  getWebPushSubscriptions,
  deleteWebPushSubscription,
  triggerWebPushNotification
} from 'common/api/webPushSubscriptions';

interface UserAgent {
  browser?: string;
  device?: string;
  platform?: string;
}

interface WebPushSubscription {
  id: number;
  user_agent: UserAgent;
  created_at: string;
}

const WebPushSubscriptionsList: React.FC = () => {
  const [subscriptions, setSubscriptions] = useState<WebPushSubscription[]>([]);
  const isAdmin = _.get(window, 'isAdmin', false);

  const onDeleteSubscription = useCallback((subscriptionIdToDelete: string | number) => {
    try {
      const pushNotificationId = window?.sessionStorage?.getItem('push_notification_id');
      deleteWebPushSubscription(subscriptionIdToDelete);
      setSubscriptions((prev) => prev.filter((subscription) => subscription.id !== subscriptionIdToDelete));
      if (pushNotificationId && pushNotificationId == subscriptionIdToDelete) {
        window?.sessionStorage?.removeItem('subscriberData');
        window?.sessionStorage?.removeItem('push_notification_id');
      }
    } catch (error) { 
      console.error('Error deleting subscription:', error);
    }
  }, []);

  const onTriggerWebPushNotification = useCallback(() => {
    triggerWebPushNotification(window.currentUserId)
      .then(() => {
        console.log('Web Push Notification triggered successfully');
      })
      .catch((error) => {
        console.error('Error triggering Web Push Notification:', error);
      });
  }, []);

  const renderSubscription = useCallback((subscription: WebPushSubscription) => (
    <tr className="subscription" key={subscription.id}>
      <td>{_.get(subscription, 'user_agent.browser')}</td>
      <td>{_.get(subscription, 'user_agent.device')}</td>
      <td>{_.get(subscription, 'user_agent.platform')}</td>
      <td>{moment(subscription.created_at).fromNow()}</td>
      <td>
        <button
          type="button"
          className="delete-btn align-self-end mb-2 mb-xm-0"
          onClick={() => onDeleteSubscription(subscription.id)}
        >
          <i className="material-icons-outlined">delete_outline</i>
        </button>
      </td>
    </tr>
  ), [onDeleteSubscription]);

  const renderSubscriptions = () => {
    if (_.isEmpty(subscriptions)) {
      return (
        <tr>
          <td colSpan={5} className="text-center text-muted">No Subscriptions...</td>
        </tr>
      );
    }
    return subscriptions.map(renderSubscription);
  };

  useEffect(() => {
    getWebPushSubscriptions().then((subs: WebPushSubscription[]) => {
      setSubscriptions(subs)
      if(_.isEmpty(subs)) window?.sessionStorage?.removeItem('subscriberData')
    });
  }, []);

  return (
    <>
      <div className='d-flex justify-content-between align-items-center'>
        <h4 className="mt-5">Browser Notification Subscriptions</h4>
        {!!isAdmin && <div className="mt-5 info-view-value">
          <small
            onClick={_.throttle(() => onTriggerWebPushNotification(), 2000)}
            className="cursor-pointer text-primary"
          ><p>Trigger Push Notification</p></small>
        </div>}
      </div>
      <div className="card mt-3">
        <div className="table-responsive">
          <table className="table mb-0">
            <thead>
              <tr>
                <th>Browser</th>
                <th>Device</th>
                <th>OS</th>
                <th>Created At</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {renderSubscriptions()}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default WebPushSubscriptionsList;
